/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationNameAvailableDTO
 */
export interface OrganizationNameAvailableDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationNameAvailableDTO
     */
    available: boolean;
}

/**
 * Check if a given object implements the OrganizationNameAvailableDTO interface.
 */
export function instanceOfOrganizationNameAvailableDTO(value: object): value is OrganizationNameAvailableDTO {
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function OrganizationNameAvailableDTOFromJSON(json: any): OrganizationNameAvailableDTO {
    return OrganizationNameAvailableDTOFromJSONTyped(json, false);
}

export function OrganizationNameAvailableDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationNameAvailableDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'],
    };
}

export function OrganizationNameAvailableDTOToJSON(value?: OrganizationNameAvailableDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'available': value['available'],
    };
}

